import { TagInfo } from "@/apis/table/types";
import { Dimension } from "@/types/mapping";
import { MemberViewType } from "./types";

export const toTagInfo = (
  tag: MemberViewType,
  dimension: Dimension,
): TagInfo => {
  return {
    name: tag.name,
    label: tag.label,
    prefix: tag.prefix,
    type: dimension === "LINE_ITEM" ? "LINE_ITEM" : "MEMBER",
    id: tag.id,
    parent: tag.parent,
    roleKey: tag.role?.key ?? "",
  };
};
